export default __webpack_public_path__ + "static/media/Trend1.66edc060.svg";